"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextPopup = void 0;
var DOMHelper_1 = require("./DOMHelper");
var hideTimer;
var TextPopup = /** @class */ (function () {
  function TextPopup(title, hideTimeout) {
    if (hideTimeout === void 0) {
      hideTimeout = 5000;
    }
    var _a, _b, _c;
    //create popup
    var parent =
      (_b = document.getElementById((_a = _LogContext.logConfig.rootElementId) !== null && _a !== void 0 ? _a : "")) !==
        null && _b !== void 0
        ? _b
        : DOMHelper_1.DOMHelper.getBody();
    this.domTree =
      (_c = document.getElementById("textPopup")) !== null && _c !== void 0
        ? _c
        : DOMHelper_1.DOMHelper.createElementWithParent("div", parent, "textPopup");
    this.domTitle = DOMHelper_1.DOMHelper.createDivWithParent(this.domTree, null, "title", title);
    //style
    this.domTree.style.zIndex = "999";
    this.domTree.style.position = "absolute";
    this.domTree.style.width = "80%";
    this.domTree.style.height = "120px";
    this.domTree.style.left = "50%";
    this.domTree.style.top = "50%";
    this.domTree.style.transform = "translate(-50%,-50%)";
    this.domTree.style.borderRadius = "20px";
    this.domTree.style.fontFamily = "Heebo, sans-serif";
    this.domTree.style.border = "solid #333";
    //title
    this.domTitle.style.fontSize = "24px";
    this.domTitle.style.textAlign = "center";
    this.domTitle.style.paddingTop = "40px";
    //line
    // this.codeLine.style.display = "flex";
    // this.codeLine.style.justifyContent = "space-around";
    // this.codeLine.style.width = "80%";
    // this.codeLine.style.margin = "auto";
    // this.codeLine.style.marginTop = "50px";
    if (_LogContext.logConfig.lightUI) {
      //title
      this.domTitle.style.color = "rgb(3,3,3)";
      //line
      // this.codeLine.style.color = "rgb(3,3,3)";
    } else {
      //page
      this.domTree.style.backgroundColor = "rgb(20,22,24)";
      this.domTree.style.boxShadow = "0 10px 50px black";
      this.domTree.style.color = "rgb(85,85,85)";
      //title
      this.domTitle.style.color = "rgb(252, 252, 252)";
      //code line
      // this.codeLine.style.color = "rgb(252,252,252)";
    }
    if (hideTimer) clearInterval(hideTimer);
    var that = this;
    hideTimer = window.setInterval(function () {
      that.destroy();
    }, hideTimeout);
  }
  TextPopup.prototype.destroy = function () {
    var _a;
    (_a = this.domTree) === null || _a === void 0 ? void 0 : _a.remove();
  };
  return TextPopup;
})();
exports.TextPopup = TextPopup;
//# sourceMappingURL=textPopup.js.map
